import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faGraduationCap, faSchool, faUniversity, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { Experience } from "./Skillss";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const generateDots = (count) => {
    const dots = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 10 + 5;
      const opacity = Math.random() * (1 - 0.3) + 0.3; // Random opacity between 0.3 and 1
      dots.push(
        <div
          key={i}
          className="dot"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            opacity: opacity,
            animationDuration: `${Math.random() * 5 + 3}s`
          }}
        ></div>
      );
    }
    return dots;
  };

  return (
    <section className="education-skill" id="education-skill">
      <style jsx>{`
        .education-bx {
          margin-bottom: 50px;
          color: #fff;
        }
        .timeline {
          position: relative;
          padding-left: 40px;
        }
        .timeline:before {
          content: '';
          position: absolute;
          top: 0;
          left: 20px;
          height: 100%;
          width: 2px;
          background: #fff;
        }
        .timeline-item {
          position: relative;
          margin-bottom: 20px;
          padding-left: 20px;
        }
        .timeline-item:before {
          content: '';
          position: absolute;
          top: 0;
          left: -8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #fff;
          border: 2px solid #fff;
        }
        .timeline-item .timeline-content {
          padding: 10px 20px;
          background: #1a1a1a;
          border-radius: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
          .chip-set {
  display: flex;
  flex-wrap: wrap;        /* allows wrapping on small screens */
  gap: 8px;               /* spacing between chips */
  margin-top: 12px;
}

.chip {
  display: inline-block;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 500;
  color: #f5f7ff;
  background: rgba(124, 58, 237, 0.15);  /* soft violet */
  border: 1px solid rgba(124, 58, 237, 0.3);
  border-radius: 999px;   /* full pill shape */
  transition: all 0.2s ease;
}

.chip:hover {
  background: rgba(124, 58, 237, 0.3);
  border-color: rgba(124, 58, 237, 0.6);
  transform: translateY(-2px);
}

        .timeline-item .timeline-content h3 {
          margin-top: 0;
          color: #fff;
        }
        .timeline-item .timeline-content span {
          display: block;
          margin-bottom: 5px;
          color: #bbb;
        }
        .timeline-item .timeline-content p {
          margin-bottom: 0;
          color: #fff;
        }
        .skill-bx {
          margin-top: 50px;
        }
        .skill-bx h2, .skill-bx p {
          color: #fff;
        }
        .item h5 {
          color: #fff;
        }
        .experience-bx {
          margin-top: 50px;
        }
        .experience-bx h2 {
          color: #fff;
          margin-bottom: 20px;
        }
        .experience-item {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          color: #fff;
        }
        .experience-item .icon {
          margin-right: 15px;
          color: #fff;
        }
        .experience-item .content {
          flex: 1;
        }
        .experience-item .content h3 {
          margin: 0;
          color: #fff;
        }
        .experience-item .content span {
          display: block;
          margin-bottom: 5px;
          color: #bbb;
        }
        .experience-item .content p {
          margin: 0;
        }
        .education-skill {
          background: linear-gradient(180deg, rgba(128, 0, 128, 0.4), rgba(0, 0, 128, 0.4), rgba(0, 128, 128, 0.4), rgba(0, 0, 128, 0.4));
          padding: 50px 0;
          position: relative;
          overflow: hidden;
        }
        .skill-slider .item {
          background: #333;
          padding: 30px;
          border-radius: 6px;
          text-align: center;
        }
        .background-image-left {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.1;
          z-index: -1;
        }
        .dot {
          position: absolute;
          background: #fff;
          border-radius: 50%;
          animation: float 5s infinite;
        }
        @keyframes float {
          0% {
            transform: translateY(0);
            opacity: 0.6;
          }
          50% {
            transform: translateY(-20px);
            opacity: 0.8;
          }
          100% {
            transform: translateY(0);
            opacity: 0.6;
          }
        }
        .education-bx, .skill-bx, .experience-bx {
          position: relative;
          z-index: 1;
        }
        .experience-item.full-stack-1 .timeline-content {
          border-radius: 10px;
        }
        .experience-item.full-stack-2 .timeline-content {
          border-radius: 20px;
        }
      `}</style>
      <div className="container">
        <div id="experience">
          <div className="row">
            <div className="col-12">
              <div className="experience-bx wow zoomIn">
                <h2>Experience</h2>

                <p className="experience-intro">
                  <strong>2.5+ years</strong> of professional experience delivering
                  <strong> 8+ production-grade projects</strong> across
                  <strong> AI automation, SaaS platforms, HRMS, and business websites</strong>.
                  Known for being <strong>cost-effective</strong>, fast-moving, and owning
                  projects end-to-end — from requirements to deployment — while collaborating
                  with startups and organizations across India and Canada.
                </p>

                <div className="timeline">

                  {/* Freelance / Multi-Org */}
                  <div className="timeline-item full-stack-1">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />

                    <div className="timeline-content">
                      <div className="exp-header">
                        <h3>Freelance Full Stack & AI Engineer</h3>
                        <span className="exp-details">
                          <FontAwesomeIcon icon={faGlobe} /> Remote | Feb 2025 — Present
                        </span>
                      </div>

                      <p>
                        Working as an independent Full Stack & AI Engineer, collaborating with
                        <strong> Indian and international clients</strong>. Delivered projects for
                        <strong> Giga Genesis Tech</strong>, <strong>NeuriX AI</strong>,
                        <strong> Nexografix</strong>, and <strong> Cuzera</strong>, building
                        <strong> AI-powered platforms</strong>, <strong>SaaS products</strong>,
                        <strong> automation systems</strong>, and
                        <strong> business-critical web applications</strong> with end-to-end
                        ownership from architecture to production.
                      </p>

                      <ul>
                        <li>
                          Built <strong>AI automation and SaaS platforms</strong> with scalable
                          backends, secure APIs, and role-based admin dashboards.
                        </li>
                        <li>
                          Developed <strong>AI-driven features</strong>, internal tools, and
                          <strong> production-grade platforms</strong> for startups and service
                          businesses.
                        </li>
                        <li>
                          Delivered <strong>service and insurance-focused websites</strong>
                          optimized for performance, SEO, and lead conversion.
                        </li>
                        <li>
                          Created <strong>custom task & workflow management systems</strong>
                          (Zeelike-style) including task tracking, assignments, and activity logs.
                        </li>
                        <li>
                          Built <strong>matrimonial platforms</strong>, <strong>business portals</strong>,
                          and <strong>internal management systems</strong> tailored to client needs.
                        </li>
                        <li>
                          Led accessibility-focused development including
                          <strong> WCAG-compliant alt-text generation</strong> using custom LLM
                          pipelines and AI workflows.
                        </li>
                        <li>
                          Working with <strong>confidential Indian and Canadian clients</strong> on
                          <strong> AI products and HRMS platforms</strong> under NDA agreements.
                        </li>
                      </ul>

                      <div className="chip-set">
                        <span className="chip">AI Automation</span>
                        <span className="chip">SaaS</span>
                        <span className="chip">HRMS</span>
                        <span className="chip">Task Management Systems</span>
                        <span className="chip">Insurance Platforms</span>
                        <span className="chip">LLMs</span>
                        <span className="chip">Accessibility (WCAG)</span>
                        <span className="chip">System Design</span>
                      </div>
                    </div>
                  </div>


                  {/* AliveHire */}
                  <div className="timeline-item full-stack-2">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <div className="exp-header">
                        <h3>Technical Lead — AliveHire</h3>
                        <span className="exp-details">
                          <FontAwesomeIcon icon={faGlobe} /> Remote | May 2025 — Jan 2026
                        </span>
                      </div>

                      <p>
                        Led architecture and development of <strong>AliveHire</strong>,
                        a scalable <strong>AI-powered recruitment and upskilling platform</strong>.
                        Owned system design and implementation across multiple user roles.
                      </p>

                      <ul>
                        <li>
                          Built <strong>AI resume parsing & ATS optimization</strong> pipelines.
                        </li>
                        <li>
                          Designed <strong>conversational AI interviews</strong>
                          with scoring and feedback.
                        </li>
                        <li>
                          Developed recruiter, hiring-partner, and institute portals.
                        </li>
                        <li>
                          Implemented scalable backend workflows and deployment pipelines.
                        </li>
                      </ul>

                      <div className="chip-set">
                        <span className="chip">React</span>
                        <span className="chip">Node.js</span>
                        <span className="chip">Laravel</span>
                        <span className="chip">AI/LLMs</span>
                        <span className="chip">Scalable Systems</span>
                      </div>
                    </div>
                  </div>

                  {/* Jobeyze */}
                  <div className="timeline-item full-stack-3">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <div className="exp-header">
                        <h3>Full Stack Developer — Jobeyze Canada</h3>
                        <span className="exp-details">
                          <FontAwesomeIcon icon={faGlobe} /> Remote | Canada | Oct 2024 — Apr 2025
                        </span>
                      </div>

                      <p>
                        Worked on <strong>AI-powered hiring automation</strong> and
                        <strong> job-matching systems</strong> to streamline recruitment
                        workflows for employers and candidates.
                      </p>

                      <ul>
                        <li>ATS automation with resume parsing and AI shortlisting.</li>
                        <li>AI resume optimization to improve matching accuracy.</li>
                        <li>Interview scheduling, assessments, and alert systems.</li>
                      </ul>

                      <div className="chip-set">
                        <span className="chip">Laravel</span>
                        <span className="chip">React</span>
                        <span className="chip">Node.js</span>
                        <span className="chip">AI Models</span>
                      </div>
                    </div>
                  </div>

                  {/* Byte Craft */}
                  <div className="timeline-item">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <div className="exp-header">
                        <h3>Full Stack Developer — Byte Craft Studios</h3>
                        <span className="exp-details">
                          <FontAwesomeIcon icon={faGlobe} /> Remote | India | May 2024 — Sep 2024
                        </span>
                      </div>

                      <p>
                        Delivered multiple <strong>business-grade web applications</strong>
                        and platforms for diverse clients with a focus on performance
                        and maintainability.
                      </p>

                      <ul>
                        <li>Built service websites and business platforms.</li>
                        <li>Developed admin dashboards and secure payment flows.</li>
                        <li>Optimized applications for SEO and scalability.</li>
                      </ul>

                      <div className="chip-set">
                        <span className="chip">MERN</span>
                        <span className="chip">Laravel</span>
                        <span className="chip">Tailwind</span>
                        <span className="chip">Filament</span>
                      </div>
                    </div>
                  </div>

                  {/* Mega Computers */}
                  <div className="timeline-item">
                    <FontAwesomeIcon icon={faBriefcase} size="2x" />
                    <div className="timeline-content">
                      <div className="exp-header">
                        <h3>Freelance Full Stack Developer — Mega Computers Pvt Ltd</h3>
                        <span className="exp-details">
                          <FontAwesomeIcon icon={faGlobe} /> Ludhiana, India | Mar 2023 — Apr 2024
                        </span>
                      </div>

                      <p>
                        Partnered with an IT firm to deliver multiple client projects,
                        gaining strong experience in full-cycle development and deployment.
                      </p>

                      <ul>
                        <li>Built web apps and automation tools using Laravel and React.</li>
                        <li>Developed ERP-style workflows and dashboards.</li>
                        <li>Handled requirements, coding, and deployment independently.</li>
                      </ul>

                      <div className="chip-set">
                        <span className="chip">Laravel</span>
                        <span className="chip">React</span>
                        <span className="chip">FastAPI</span>
                        <span className="chip">CI/CD</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: '40px', marginBottom: '40px' }}>
          <div className="col-12">
            <div className="education-bx wow zoomIn">
              <h2>Education</h2>

              <div className="timeline">

                {/* B.Tech */}
                <div className="timeline-item">
                  <FontAwesomeIcon icon={faGraduationCap} size="2x" />
                  <div className="timeline-content">
                    <div className="d-flex justify-content-between align-items-center">
                      <h3 className="mb-0">
                        Indian Institute of Information Technology, Manipur
                      </h3>
                      <span className="location text-white">Manipur, India</span>
                    </div>

                    <div className="edu-header">
                      <span>2021 — 2025</span>
                      <span className="highlight">
                        CPI: <strong>8.5</strong>
                      </span>
                    </div>

                    <p>
                      <strong>B.Tech in Computer Science & Engineering (CSE)</strong>
                    </p>

                    <p className="meta-line">
                      Strong academic foundation in
                      <em> Data Structures, Algorithms, System Design, AI & ML, Cloud,
                        and Full-Stack Development</em>, supported by multiple academic
                      and industry-oriented projects.
                    </p>
                  </div>
                </div>

                {/* Class 12 */}
                <div className="timeline-item">
                  <FontAwesomeIcon icon={faSchool} size="2x" />
                  <div className="timeline-content">
                    <div className="d-flex justify-content-between align-items-center">
                      <h3 className="mb-0">
                        Bhartiya Vidya Mandir, Udham Singh Nagar
                      </h3>
                      <span className="location text-white">
                        Ludhiana, Punjab, India
                      </span>
                    </div>

                    <div className="edu-header">
                      <span>2019 — 2020</span>
                      <span className="highlight">
                        Percentage: <strong>91%</strong>
                      </span>
                    </div>

                    <p>
                      <strong>
                        Senior Secondary (CBSE) | PCM & Computer Science
                      </strong>
                    </p>

                    <p className="meta-line">
                      Built strong fundamentals in
                      <em> Physics, Chemistry, Mathematics, and Computer Science</em>,
                      with a focus on analytical thinking and programming basics.
                    </p>
                  </div>
                </div>

                {/* Class 10 */}
                <div className="timeline-item">
                  <FontAwesomeIcon icon={faUniversity} size="2x" />
                  <div className="timeline-content">
                    <div className="d-flex justify-content-between align-items-center">
                      <h3 className="mb-0">
                        Bhartiya Vidya Mandir, Udham Singh Nagar
                      </h3>
                      <span className="location text-white">
                        Ludhiana, Punjab, India
                      </span>
                    </div>

                    <div className="edu-header">
                      <span>2017 — 2018</span>
                      <span className="highlight">
                        Percentage: <strong>90%</strong>
                      </span>
                    </div>

                    <p>
                      <strong>Secondary Education (CBSE) | Class 10</strong>
                    </p>

                    <p className="meta-line">
                      Developed a solid base in
                      <em> Mathematics, Science, and Logical Reasoning</em>, forming
                      the groundwork for advanced technical education.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div>
          <Experience></Experience>
        </div>
      </div>
      <div className="background-image-left">
        {generateDots(100)}
        <img className="background-image-left" src={colorSharp} alt="background" />
      </div>
    </section>
  );
};
